import { useContext } from "react";
import { DriveContext } from "@/store/DriveContext";
import { useNavigate } from "react-router-dom";

function TopBar() {
  const { user, onlinePlayersCount } = useContext(DriveContext)!;
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/signin");
  };

  return (
    <div className="flex items-center justify-between px-4 sm:px-6 h-14 sm:h-[62px] shrink-0 bg-[#101020]/95 backdrop-blur-md border-b border-violet-500/15 relative z-20">
      {/* Brand */}
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 sm:w-[34px] sm:h-[34px] bg-gradient-to-br from-violet-500 to-indigo-500 rounded-lg flex items-center justify-center text-[15px] font-extrabold text-white shadow-[0_4px_12px_rgba(139,92,246,0.4)]">
          M
        </div>
        <span className="text-lg font-extrabold bg-gradient-to-br from-violet-300 to-indigo-100 bg-clip-text text-transparent tracking-tight">
          Matrix
        </span>
      </div>

      {/* Right controls */}
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-1 px-2.5 py-1 bg-violet-500/10 border border-violet-500/20 rounded-full text-xs font-semibold text-violet-300 whitespace-nowrap">
          <span className="text-[13px]">🟢</span>
          {onlinePlayersCount} Online
        </div>
        
        <button className="w-8 h-8 sm:w-[34px] sm:h-[34px] bg-gradient-to-br from-violet-500 to-indigo-500 rounded-full border-none cursor-pointer flex items-center justify-center text-[13px] font-bold text-white shrink-0 hover:shadow-[0_0_0_3px_rgba(139,92,246,0.35)] transition-shadow">
          {user?.username?.[0]?.toUpperCase() ?? ":)"}
        </button>
        
        <button 
          className="flex items-center gap-1 px-2.5 py-1 bg-red-500/10 border border-red-500/20 rounded-full text-[11px] font-semibold text-red-400 cursor-pointer hover:bg-red-500/15 hover:border-red-500/40 transition-all font-sans"
          onClick={handleLogout}
        >
          Exit
        </button>
      </div>
    </div>
  );
}

export default TopBar;
